import axios from "axios";
import { BUSY_CALLERS_CHANGE } from "../reducers/types";
import { defaultHeader } from "../constants/defaultItems";
import { toast } from "@/components/ui/use-toast";

const CancelToken = axios.CancelToken;
let isRefreshingRequest = false;
var pendingRequestsQueue = [];

export const setupAxiosInterceptor = (dispatch) => {
  axios.interceptors.request.use(
    (config) => {
      //ACTIVATE BUSY CALLER
      if (config && config.url)
        dispatch({
          type: BUSY_CALLERS_CHANGE,
          payload: {
            key: config.url,
            isBusy: true,
          },
        });
      // if (!localStorage.SessionToken) {
      //   return config;
      // }

      //   if (
      //     !isAccessTokenValid() &&
      //     config.url.toLowerCase().indexOf("getnewaccesstoken") === -1
      //   ) {
      //     return Promise.reject({ reason: INTENTIONAL_ERROR, config: config });
      //   }

      if (config.headers["TravelERP"]) {
        config.headers.Authorization = `Bearer ${localStorage.token}`;
        config.headers.apiPath = config.headers.apiPath ?? config.url;
        if (config.method.toUpperCase() === "POST") {
          config.url = `/TravelApi/PostData`;
        } else {
          let query = config.url.split("?");
          let queryString = "";
          if (query.length > 1) {
            queryString = query[1];
          }
          config.url = `/TravelApi/GetData${queryString !== "" ? "?" + queryString : ""
            }`;
        }
      }

      return config;
    },
    (error) => {
      // DEACTIVATE BUSY CALLER
      if (error && error.config && error.config.url)
        dispatch({
          type: BUSY_CALLERS_CHANGE,
          payload: {
            key: error.config.url,
            isBusy: false,
          },
        });

      Promise.reject(error);
    }
  );
  axios.interceptors.response.use(
    (response) => {
      const originalRequestPath = response.config.headers.apiPath;
      try {
        dispatch({
          type: BUSY_CALLERS_CHANGE,
          payload: {
            key: originalRequestPath,
            isBusy: false,
          },
        });
        dispatch({
          type: BUSY_CALLERS_CHANGE,
          payload: {
            key: response.config.url,
            isBusy: false,
          },
        });
      } catch (e) { }
      return response;
    },
    async function (error) {
      let errorResponse = error.response;
      let originalRequest = error.config;
      if (error && error.config && error.config.url)
        dispatch({
          type: BUSY_CALLERS_CHANGE,
          payload: {
            key: originalRequest.headers.apiPath,
            isBusy: false,
          },
        });

      if (error.response.status === 401) {
        if (isRefreshingRequest) {
          return new Promise(function (resolve, reject) {
            pendingRequestsQueue.push({ resolve, reject });
          })
            .then((token) => {
              originalRequest.headers = {
                ...originalRequest.headers,
                Authorization: "Bearer " + token,
              };
              // originalRequest.headers['Authorization'] = 'Bearer ' + token;
              return axios(originalRequest);
            })
            .catch((err) => {
              console.log(
                "error occured while processing pendingRequestsQueue",
                err
              );
              return err;
            });
        }

        originalRequest._retry = true;
        isRefreshingRequest = true;

        return new Promise(function (resolve, reject) {
          const newTokenUrl = "/TravelApi/GetData";
          const apiPath = "/api/UserAccount/RefreshAccessToken?";
          var params = new URLSearchParams({ userName: localStorage.userName });
          // dispatch({
          //   type: BUSY_CALLERS_CHANGE,
          //   payload: {
          //     key: newTokenUrl,
          //     isBusy: true,
          //   },
          // });
          // refresh token from axios call
          axios
            .get(newTokenUrl, {
              headers: {
                apiPath: apiPath + params,
                refreshToken: localStorage.refreshToken,
              },
            })
            .then((resp) => {
              dispatch({
                type: BUSY_CALLERS_CHANGE,
                payload: {
                  key: newTokenUrl,
                  isBusy: false,
                },
              });

              if (resp.data.IsAuthenticate) {
                localStorage.token = resp.data.AccessToken;
                localStorage.refreshTokenExpTime =
                  resp.data.RefreshTokenExpireMinute;

                axios.defaults.headers.common["Authorization"] =
                  "Bearer " + resp.data.AccessToken;

                originalRequest.headers = {
                  ...originalRequest.headers,
                  Authorization: "Bearer " + resp.data.AccessToken,
                };

                processQueue(null, resp.data.AccessToken);

                resolve(axios(originalRequest));
                isRefreshingRequest = false;
              } else {
                pendingRequestsQueue = [];
                sessionExpiryAction();
                //return Promise.reject(response);
              }
            })
            .catch((err) => {
              dispatch({
                type: BUSY_CALLERS_CHANGE,
                payload: {
                  key: apiPath,
                  isBusy: false,
                },
              });

              processQueue(err, null);
              reject(err);
              // sessionExpiryAction();
            })
            .then(() => {
              isRefreshingRequest = false;
            });
        });
      }
      return Promise.reject(error);
    }
  );
};

function sessionExpiryAction() {
  if (localStorage.refreshToken) {
    localStorage.clear();
  }
  toast({
    variant: "destructive",
    title: "Session expired",
    description:
      "Your current login session has been expired! Please login to continue.",
  });
  loginWithoutDispatch(`${window.location.pathname}${window.location.search}`);
  if (localStorage.length > 0) {
    toast({
      variant: "destructive",
      title:
        "Localstorage values are still available, please clear the localstorage and go again",
      description:
        "Your current session has been expired. Login to continue.....",
    });
  }
}
const processQueue = (error, token = null) => {
  pendingRequestsQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  pendingRequestsQueue = [];
};
export const loginWithoutDispatch = (url) => {
  if (
    url.toLowerCase().includes("unauthorized") ||
    url.toLowerCase().includes("logout")
  )
    window.location.href = "/Login";
  else window.location.href = "/auth/login?redirect_to=" + url;
};
